export const IS_MAC = navigator.platform.includes('Mac');
